import React, { useEffect, useRef, useState } from 'react';

interface TypingIndicatorProps {
  name?: string;
  className?: string;
}

// Smooth, looping typing indicator with blinking caret and cycling dots
const TypingIndicator: React.FC<TypingIndicatorProps> = ({ name = 'Sarah', className = '' }) => {
  const base = `${name} is typing`;
  const [index, setIndex] = useState(0); // characters typed
  const [dots, setDots] = useState(0);   // 0..3
  const cycles = useRef(0);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    const schedule = (ms: number, fn: () => void) => {
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(fn, ms);
    };

    const step = () => {
      // type base string
      if (index < base.length) {
        const variance = 50 + Math.random() * 90; // natural typing variance
        setIndex((i) => i + 1);
        schedule(variance, step);
        return;
      }

      // after full text, animate dots 0..3 a few cycles then restart
      setDots((d) => (d + 1) % 4);
      cycles.current += 1;
      if (cycles.current > 12) {
        // reset loop
        cycles.current = 0;
        setDots(0);
        setIndex(0);
        schedule(500, step);
        return;
      }
      schedule(220, step);
    };

    schedule(400, step);
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base]);

  const text = `${base.slice(0, index)}${index >= base.length ? '.'.repeat(dots) : ''}`;

  return (
    <span className={`inline-flex items-center ${className}`}>
      <span>{text}</span>
      <span className="typing-caret ml-0.5" aria-hidden="true" />
    </span>
  );
};

export default TypingIndicator;


